import React from 'react';
import PropTypes from 'prop-types';
import ConnectedRoleManager from './ConnectedRoleManager';

const RoleManagerRouting = ({ match }) => <ConnectedRoleManager />;

RoleManagerRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default RoleManagerRouting;
